import { useEffect, useState } from "react";
import Router from "next/router";
import { moveToErrorPage } from "@/libs/errors";
import { useGetMyBizsolStateLazyQuery, BizsolState } from "@/generated/graphql";
import { AuthStatus } from "@/contexts/AuthContext";

type Props = {
  authStatus: AuthStatus;
  isNotReady?: boolean; // authStatus 以外で実行を制御したい場合に指定する
};

const useMoveToBizsolLoginIfWaitingState = ({
  authStatus,
  isNotReady,
}: Props) => {
  const [passed, setPassed] = useState(false);

  const [getBizsolStateQuery, { called }] = useGetMyBizsolStateLazyQuery({
    onCompleted: (data) => {
      if (data?.me?.bizsolState === BizsolState.Waiting) {
        Router.push("/bizsol/redirect-login");
      } else {
        setPassed(true);
      }
    },
    onError: () => {
      moveToErrorPage();
    },
  });

  useEffect(() => {
    if (authStatus !== AuthStatus.SignedIn || isNotReady) {
      return;
    }
    if (!called) {
      getBizsolStateQuery();
    }
  }, [authStatus, isNotReady]);

  return { passed };
};

export default useMoveToBizsolLoginIfWaitingState;
